import get from 'transmute/get';
export const getFileUploads = get('fileUploads');